import React, { useState, useEffect } from "react";
import { User, Lock, Mail, Phone, UserPlus, Clock, CheckCircle } from "lucide-react";
import { useNavigate } from "react-router-dom";
import "../../Dashboard.css";
import "./cadastro.css";

const Cadastro = () => {
  const [newUser, setNewUser] = useState({
    email: "",
    usuario: "",
    senha: "",
    action: "register",
    telefone: "",
  });
  const [message, setMessage] = useState("");
  const [isSuccess, setIsSuccess] = useState(false);
  const [timeLeft, setTimeLeft] = useState(5); 
  const navigate = useNavigate();

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewUser({ ...newUser, [name]: value });
  };

  const handleCreateUser = (e) => {
    e.preventDefault();

    fetch("https://sismoney.com/painel/usuarios.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(newUser),
    })
      .then((response) => response.json())
      .then((res) => {
        if (res.success) {
          setIsSuccess(true);
        } else {
          setMessage(`Erro: ${res.message}`);
        }
      })
      .catch((error) => setMessage("Erro ao criar usuário: " + error));
  };

  useEffect(() => {
    if (isSuccess) {
      const timer = setInterval(() => {
        setTimeLeft((prevTime) => {
          if (prevTime <= 1) {
            clearInterval(timer);
            navigate("/login"); // Redirecionar para a página de login
          }
          return prevTime - 1;
        });
      }, 1000); // Atualiza a cada 1 segundo
      return () => clearInterval(timer); // Limpeza do intervalo
    }
  }, [isSuccess, navigate]);

  if (isSuccess) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-indigo-500 to-purple-600 p-4">
        <div className="bg-white dark:bg-gray-800 p-8 rounded-lg shadow-xl max-w-lg w-full text-center space-y-6">
          {/* Ícone de Sucesso */}
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-green-100 dark:bg-green-900/50 mb-4">
            <CheckCircle className="w-8 h-8 text-green-600 dark:text-green-400" />
          </div>

          <h2 className="text-3xl font-semibold text-gray-900 dark:text-white">CONTA CRIADA COM SUCESSO</h2>

          <p className="text-lg text-gray-600 dark:text-gray-400">
            Você ganhou 5 dias grátis! Utilize o sistema o máximo que conseguir.
          </p>

          <div className="space-y-2">
            <p className="text-md text-gray-600 dark:text-gray-400">
              <Clock className="inline-block w-5 h-5 mr-2 text-yellow-500" />
              Você será redirecionado para o login em {timeLeft} segundos.
            </p>
          </div>

          <button
            onClick={() => navigate("/login")}
            className="inline-flex items-center px-6 py-3 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
          >
            <CheckCircle className="w-5 h-5 mr-2" />
            FAÇA O LOGIN AQUI
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-indigo-500 to-purple-600 flex items-center justify-center p-4">
      <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-xl max-w-md w-full p-8 space-y-8">
        <div className="text-center">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-indigo-100 dark:bg-indigo-900/50 mb-4">
            <UserPlus className="w-8 h-8 text-indigo-600 dark:text-indigo-400" />
          </div>
          <h2 className="text-3xl font-bold text-gray-900 dark:text-white">
            Cadastro de Usuário
          </h2>
        </div>

        <form onSubmit={handleCreateUser} className="space-y-6">
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
              Email
            </label>
            <div className="relative">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <Mail className="h-5 w-5 text-gray-400" />
              </div>
              <input
                type="email"
                name="email"
                placeholder="Digite seu email"
                value={newUser.email}
                onChange={handleInputChange}
                className="block w-full pl-10 pr-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 dark:bg-gray-700 dark:text-white"
                required
              />
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
              Telefone
            </label>
            <div className="relative">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <Phone className="h-5 w-5 text-gray-400" />
              </div>
              <input
                type="tel"
                name="telefone"
                placeholder="Digite seu telefone"
                value={newUser.telefone}
                onChange={handleInputChange}
                className="block w-full pl-10 pr-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 dark:bg-gray-700 dark:text-white"
                required
              />
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
              Usuário
            </label>
            <div className="relative">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <User className="h-5 w-5 text-gray-400" />
              </div>
              <input
                type="text"
                name="usuario"
                placeholder="Digite seu usuário"
                value={newUser.usuario}
                onChange={handleInputChange}
                className="block w-full pl-10 pr-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 dark:bg-gray-700 dark:text-white"
                required
              />
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
              Senha
            </label>
            <div className="relative">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <Lock className="h-5 w-5 text-gray-400" />
              </div>
              <input
                type="password"
                name="senha"
                placeholder="Digite sua senha"
                value={newUser.senha}
                onChange={handleInputChange}
                className="block w-full pl-10 pr-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 dark:bg-gray-700 dark:text-white"
                required
              />
            </div>
          </div>

          <button
            type="submit"
            className="w-full flex items-center justify-center px-4 py-2 border border-transparent text-base font-medium rounded-lg text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-colors"
          >
            <UserPlus className="w-5 h-5 mr-2" />
            Cadastrar
          </button>
        </form>

        {message && <p className="message text-red-500 text-center">{message}</p>}
      </div>
    </div>
  );
};

export default Cadastro;
